import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["audience", "teams", "onChangeAudience", "onChangeTeams"];
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useUniqueId from 'hooks/useUniqueId';
import toArray from 'utils/toArray';
import { isValidSetAudience } from 'types/skills';
import FormField, { FormFieldAlignedContent } from 'components/FormField';
import Stack from 'components/Stack';
import RadioButtonOption from 'components/RadioButtonOption';
import ShadedCard from 'components/ShadedCard';
import Button from 'components/Button';
import Text from 'components/Text';
import TeamPickerModal from 'screens/TeamPickerModal';
import TeamsList from './common/TeamsList';
function AudienceTeamOrAllOrNoneField(_ref) {
  var unformattedAudience = _ref.audience,
    teams = _ref.teams,
    onChangeAudience = _ref.onChangeAudience,
    onChangeTeams = _ref.onChangeTeams,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var uniqueId = useUniqueId();
  var audience = unformattedAudience || 'none';
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasTeamPickerModal = _useState2[0],
    setHasTeamPickerModal = _useState2[1];
  function handleAudienceChange(e) {
    var value = e.currentTarget.value;
    var newAudience = value === 'none' ? null : value;
    if (isValidSetAudience(newAudience)) {
      onChangeAudience(newAudience);
    }
  }
  var onRemoveTeam = function onRemoveTeam(toRemoveTeamId) {
    var teamsToRemove = teams.filter(function (item) {
      return item.id === toRemoveTeamId;
    });
    if (teamsToRemove) {
      onChangeTeams({
        toRemove: teamsToRemove
      });
    }
  };
  var onSubmitTeams = function onSubmitTeams(_ref2) {
    var toAdd = _ref2.toAdd,
      toRemove = _ref2.toRemove;
    onChangeTeams({
      toAdd: toArray(toAdd),
      toRemove: toArray(toRemove)
    });
    setHasTeamPickerModal(false);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Stack, {
    spacing: "s"
  }, /*#__PURE__*/React.createElement(FormField, _extends({
    as: "span",
    label: t('property_audience'),
    labelId: uniqueId
  }, otherProps), /*#__PURE__*/React.createElement(Stack, {
    spacing: "xs"
  }, /*#__PURE__*/React.createElement(RadioButtonOption, {
    checked: audience === 'all',
    value: "all",
    id: "can_see_everyone_radiobttn",
    onChange: handleAudienceChange,
    label: t('state_everyone')
  }), /*#__PURE__*/React.createElement(RadioButtonOption, {
    checked: audience === 'teams',
    value: "teams",
    id: "can_see_teams_radiobttn",
    onChange: handleAudienceChange,
    label: t('state_selected_teams')
  }), /*#__PURE__*/React.createElement(RadioButtonOption, {
    checked: audience === 'none',
    value: "none",
    id: "can_see_no_one_radiobttn",
    onChange: handleAudienceChange,
    label: t('state_no_one')
  }))), audience === 'teams' && /*#__PURE__*/React.createElement(FormFieldAlignedContent, null, /*#__PURE__*/React.createElement(ShadedCard, {
    px: "s",
    py: "xs"
  }, /*#__PURE__*/React.createElement(FormField, _extends({
    as: "span",
    label: t('content_type_team_plural'),
    labelId: uniqueId,
    horizontal: false
  }, otherProps), /*#__PURE__*/React.createElement(Stack, {
    spacing: "xs"
  }, teams.length === 0 ? /*#__PURE__*/React.createElement(Text, {
    dimmed: true,
    size: "s"
  }, t('amount_none')) : /*#__PURE__*/React.createElement(Stack, {
    spacing: "xs"
  }, teams.length > 0 && /*#__PURE__*/React.createElement(TeamsList, {
    teams: teams,
    onRemoveTeam: onRemoveTeam
  })), /*#__PURE__*/React.createElement(Button, {
    size: "medium",
    icon: "edit",
    onClick: function onClick() {
      return setHasTeamPickerModal(true);
    }
  }, t('actions_select_teams'))))))), hasTeamPickerModal && /*#__PURE__*/React.createElement(TeamPickerModal, {
    defaultSelectedItems: teams,
    onClose: function onClose() {
      return setHasTeamPickerModal(false);
    },
    onSubmit: onSubmitTeams
  }));
}
export default AudienceTeamOrAllOrNoneField;